import { createContext } from 'react'

/** The form's fixed grid width (12 for flow-layout forms); undefined = legacy per-row sizing. */
export const GridColumnsContext = createContext<number | undefined>(undefined)
